<div class="login-page">
  <!-- Ambient Background -->
  <div class="ambient-scene" aria-hidden="true">
    <div class="ambient-gradient"></div>
    <div class="kolam-pattern"></div>
    <div class="ambient-orb orb-a"></div>
    <div class="ambient-orb orb-b"></div>
    <div class="ambient-orb orb-c"></div>
    <div class="grid-overlay"></div>
  </div>

  <!-- Government Strip -->
  <!-- <header class="gov-strip">
    <div class="gov-strip-inner">
      <div class="gov-emblem">
        <img src="TNPGCL_logo.png" alt="TNPGCL" />
      </div>
      <div class="gov-strip-text">
        <span class="gov-label">Government of Tamil Nadu</span>
        <span class="gov-divider">|</span>
        <span class="gov-dept">Tamil Nadu Power Generation and Consultancy Limited (TNPGCL)</span>
      </div>
      <div class="gov-lang">
        <i class="bi bi-translate"></i>
        <span>தமிழ் · English</span>
      </div>
    </div>
  </header> -->

  <main class="login-main">
    <div class="login-shell">
      <!-- HERO / LEFT PANEL -->
      <section class="hero-panel">
        <div class="hero-bg-image"></div>
        <div class="hero-overlay"></div>

        <!-- Decorative Kolam Corners -->
        <svg class="kolam-corner kolam-tl" viewBox="0 0 120 120" aria-hidden="true">
          <circle
            cx="60"
            cy="60"
            r="50"
            fill="none"
            stroke="rgba(245,166,35,0.15)"
            stroke-width="1"
          />
          <circle
            cx="60"
            cy="60"
            r="35"
            fill="none"
            stroke="rgba(245,166,35,0.1)"
            stroke-width="1"
          />
          <path d="M60 10 L70 50 L60 60 L50 50 Z" fill="rgba(245,166,35,0.08)" />
          <path d="M110 60 L70 70 L60 60 L70 50 Z" fill="rgba(16,185,129,0.08)" />
        </svg>
        <svg class="kolam-corner kolam-br" viewBox="0 0 120 120" aria-hidden="true">
          <circle
            cx="60"
            cy="60"
            r="45"
            fill="none"
            stroke="rgba(16,185,129,0.12)"
            stroke-width="1"
          />
          <path d="M10 60 L50 50 L60 60 L50 70 Z" fill="rgba(245,166,35,0.06)" />
        </svg>

        <div class="hero-content">
          <!-- Brand -->
          <div class="hero-brand">
            <div class="brand-logo-ring">
              <img src="TNPGCL_logo.png" alt="TNPGCL Logo" />
            </div>
            <div class="brand-copy">
              <span class="brand-eyebrow">TNPGCL · Government of Tamil Nadu</span>
              <h1 class="brand-title">e-Ash <em>Disposal Portal</em></h1>
            </div>
          </div>

          <!-- Hero Headline -->
          <div class="hero-headline">
            <div class="hero-tag text-center">
              <i class="bi bi-shield-check"></i>
              Transparent · Accountable · Digital
            </div>

            <h2 class="text-center">
              <span class="d-block fw-bold text-white lh-sm"> Sustainable Ash Management </span>
              <span
                class="d-block fw-sm mt-1"
                style="color: rgba(255, 255, 255, 0.75); font-size: 0.92em"
              >
                for Tamil Nadu's
              </span>
              <strong class="d-block mt-1 hero-gold-text"> Industrial Future </strong>
            </h2>

            <div class="hero-desc text-center mt-3">
              <div>
                Unified enterprise platform for transparent, proportionate and automated fly ash
                allocation to MSE units / Local Users and industries across Tamil Nadu.
              </div>

              <!-- <div class="mt-2">
                allocation to industries, cement plants, brick manufacturers and MSE units across
                Tamil
              </div>

              <div class="mt-2">Nadu power stations.</div> -->
            </div>
          </div>

          <!-- Illustration: Power & Industry -->
          <div class="hero-illustration" aria-hidden="true">
            <svg class="industry-svg" viewBox="0 0 480 200" preserveAspectRatio="xMidYMax meet">
              <!-- Ground -->
              <rect x="0" y="170" width="480" height="30" fill="url(#groundGrad)" opacity="0.6" />
              <!-- Power Plant Towers -->
              <g class="plant-towers">
                <rect x="60" y="80" width="28" height="90" rx="2" fill="rgba(255,255,255,0.12)" />
                <rect x="64" y="60" width="20" height="25" rx="1" fill="rgba(255,255,255,0.08)" />
                <rect x="120" y="50" width="36" height="120" rx="2" fill="rgba(255,255,255,0.15)" />
                <rect x="128" y="30" width="20" height="25" rx="1" fill="rgba(255,255,255,0.1)" />
                <!-- Cooling towers -->
                <ellipse
                  cx="200"
                  cy="100"
                  rx="30"
                  ry="50"
                  fill="rgba(255,255,255,0.06)"
                  stroke="rgba(255,255,255,0.12)"
                  stroke-width="1"
                />
                <ellipse
                  cx="260"
                  cy="90"
                  rx="25"
                  ry="42"
                  fill="rgba(255,255,255,0.05)"
                  stroke="rgba(255,255,255,0.1)"
                  stroke-width="1"
                />
              </g>
              <!-- Transmission lines -->
              <path
                d="M90 50 L90 30 M150 30 L150 10 M210 50 L210 20"
                stroke="rgba(245,166,35,0.3)"
                stroke-width="1.5"
                fill="none"
              />
              <path
                d="M80 30 L160 10 M140 10 L220 20"
                stroke="rgba(245,166,35,0.2)"
                stroke-width="1"
                fill="none"
              />
              <!-- Fly ash truck -->
              <g class="truck-group" transform="translate(300, 130)">
                <rect
                  x="0"
                  y="10"
                  width="50"
                  height="22"
                  rx="3"
                  fill="rgba(16,185,129,0.25)"
                  stroke="rgba(16,185,129,0.4)"
                  stroke-width="1"
                />
                <rect
                  x="50"
                  y="5"
                  width="30"
                  height="27"
                  rx="3"
                  fill="rgba(16,185,129,0.35)"
                  stroke="rgba(16,185,129,0.5)"
                  stroke-width="1"
                />
                <circle
                  cx="15"
                  cy="35"
                  r="7"
                  fill="rgba(255,255,255,0.15)"
                  stroke="rgba(255,255,255,0.3)"
                  stroke-width="1"
                />
                <circle
                  cx="65"
                  cy="35"
                  r="7"
                  fill="rgba(255,255,255,0.15)"
                  stroke="rgba(255,255,255,0.3)"
                  stroke-width="1"
                />
                <rect x="5" y="0" width="40" height="12" rx="2" fill="rgba(245,166,35,0.3)" />
              </g>
              <!-- Gopuram silhouette hint -->
              <g transform="translate(380, 100)" opacity="0.15">
                <path d="M0 70 L20 0 L40 70 Z" fill="rgba(245,166,35,0.5)" />
                <path d="M10 70 L20 20 L30 70 Z" fill="rgba(245,166,35,0.3)" />
              </g>
              <defs>
                <linearGradient id="groundGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="rgba(16,185,129,0.2)" />
                  <stop offset="100%" stop-color="rgba(10,35,66,0)" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <!-- Feature Cards -->
          <div class="hero-features">
            <div class="feature-card">
              <div class="feature-icon green"><i class="bi bi-check-circle-fill"></i></div>
              <div>
                <strong>Transparent Registration</strong>
                <span>Digital onboarding for industries</span>
              </div>
            </div>
            <div class="feature-card">
              <div class="feature-icon gold"><i class="bi bi-pie-chart-fill"></i></div>
              <div>
                <strong>Proportional Allocation</strong>
                <span>Fair ash distribution system</span>
              </div>
            </div>
            <div class="feature-card">
              <div class="feature-icon blue"><i class="bi bi-bell-fill"></i></div>
              <div>
                <strong>SMS / Email & WhatsApp Alerts</strong>
                <span>Real-time status updates</span>
              </div>
            </div>
          </div>

          <!-- Stats Strip -->
          <div class="hero-stats">
            <div class="stat-item">
              <span class="stat-num">250+</span>
              <span class="stat-label">Registered Industries</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-num">15K+</span>
              <span class="stat-label">Ash Allocations</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-num">100%</span>
              <span class="stat-label">Digital Process</span>
            </div>
          </div>
        </div>
      </section>

      <!-- LOGIN FORM PANEL -->
      <section class="form-panel">
        <div class="form-panel-inner">
          <div class="form-header">
            <span class="form-welcome">{{ isOtpStep ? 'Verify OTP' : 'Welcome' }}</span>
            <h2>{{ isOtpStep ? 'Enter Verification Code' : 'Sign In to Your Account' }}</h2>
            <p *ngIf="isOtpStep" class="form-subtext">
              OTP sent to the registered mobile number for <strong>{{ pendingUsername }}</strong>
            </p>
          </div>

          <!-- User Type Tabs -->
          <div class="user-tabs" role="tablist" [class.disabled]="isOtpStep">
            <button
              class="user-tab"
              [class.active]="activeTab === 'industry'"
              (click)="selectTab('industry')"
              type="button"
              [disabled]="isOtpStep"
            >
              <i class="bi bi-building"></i>
              <span>Industry / MSE</span>
            </button>
            <button
              class="user-tab"
              [class.active]="activeTab === 'official'"
              (click)="selectTab('official')"
              type="button"
              [disabled]="isOtpStep"
            >
              <i class="bi bi-person-badge"></i>
              <span>TNPGCL Official</span>
            </button>
          </div>

          <div class="login-form">
            <form [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>
              <div class="form-field" [class.field-locked]="isOtpStep">
                <label class="form-label">User ID / Application Number</label>
                <div class="input-wrap">
                  <i class="bi bi-person icon"></i>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter your User ID or Application No."
                    autocomplete="username"
                    formControlName="userId"
                  />
                </div>
                <div
                  *ngIf="
                    !isOtpStep &&
                    loginForm.get('userId')?.touched &&
                    loginForm.get('userId')?.invalid
                  "
                  class="field-error"
                >
                  Username is required.
                </div>
              </div>

              <div class="form-field pb-2" [class.field-locked]="isOtpStep">
                <label class="form-label mt-3">Password</label>
                <div class="input-wrap">
                  <i class="bi bi-lock icon"></i>
                  <input
                    [type]="showPassword ? 'text' : 'password'"
                    class="form-control"
                    placeholder="Enter your password"
                    autocomplete="current-password"
                    formControlName="password"
                  />
                  <button
                    type="button"
                    class="pw-toggle"
                    (click)="togglePassword()"
                    title="Show/Hide password"
                    [disabled]="isOtpStep"
                  >
                    <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                  </button>
                </div>
                <div
                  *ngIf="
                    !isOtpStep &&
                    loginForm.get('password')?.touched &&
                    loginForm.get('password')?.invalid
                  "
                  class="field-error"
                >
                  Password is required.
                </div>
              </div>

              <div class="form-options" *ngIf="!isOtpStep">
                <label class="remember-check">
                  <input type="checkbox" formControlName="rememberMe" />
                  <span>Remember me</span>
                </label>
                <a href="#" class="forgot-link">Forgot Password?</a>
              </div>

              <div class="form-field" *ngIf="!isOtpStep">
                <label class="form-label mt-3">Captcha Verification</label>
                <div class="captcha-panel">
                  <div class="captcha-top">
                    <span class="captcha-code">{{ captchaCode }}</span>
                    <button
                      type="button"
                      class="btn-captcha-refresh"
                      (click)="generateCaptcha()"
                      title="Refresh Captcha"
                    >
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                  <div class="captcha-input-wrap">
                    <i class="bi bi-shield-check icon"></i>
                    <input
                      type="text"
                      class="form-control captcha-input"
                      placeholder="Enter captcha above"
                      maxlength="8"
                      formControlName="captchaInput"
                    />
                  </div>
                </div>
                <div *ngIf="captchaError" class="field-error">Captcha does not match.</div>
              </div>

              <div *ngIf="!isOtpStep && loginError" class="login-error-banner">
                <i class="bi bi-exclamation-triangle-fill"></i>
                <span>{{ loginError }}</span>
              </div>

              <button
                *ngIf="!isOtpStep"
                type="submit"
                class="btn-login"
                [disabled]="isLoading"
                [class.loading]="isLoading"
              >
                <span *ngIf="!isLoading"><i class="bi bi-box-arrow-in-right"></i> Login</span>
                <span *ngIf="isLoading" class="spinner-wrap">
                  <span class="btn-spinner"></span> Logging in...
                </span>
              </button>
            </form>

            <section *ngIf="isOtpStep" class="otp-section" [formGroup]="otpForm">
              <div *ngIf="loginSuccess" class="login-success-banner">
                <i class="bi bi-check-circle-fill"></i>
                <span>{{ loginSuccess }}</span>
              </div>

              <button type="button" class="btn-back-login" (click)="backToLogin()">
                <i class="bi bi-arrow-left"></i> Change Username / Password
              </button>

              <div class="form-field">
                <label class="form-label">Enter 4-Digit OTP</label>
                <div class="otp-input-group" (paste)="onOtpPaste($event)">
                  <input
                    *ngFor="let field of otpFields; let i = index"
                    [id]="field"
                    type="text"
                    inputmode="numeric"
                    maxlength="1"
                    class="otp-input"
                    [formControlName]="field"
                    autocomplete="one-time-code"
                    (input)="onOtpInput($event, field, i < 3 ? 'otp' + (i + 2) : '')"
                    (keydown)="onOtpKeydown($event, field, i > 0 ? 'otp' + i : '')"
                    (keydown.enter)="onVerifyOtp()"
                  />
                </div>
                <div class="field-error" *ngIf="otpForm.touched && !isOtpComplete">
                  OTP is required. Please enter all 4 digits.
                </div>
              </div>

              <div class="resend-otp-row">
                <span class="resend-label">Didn't receive the code?</span>
                <button
                  type="button"
                  class="btn-resend-otp"
                  (click)="onResendOtp()"
                  [disabled]="resendCountdown > 0 || isResendLoading || isLoading"
                >
                  <span *ngIf="isResendLoading" class="spinner-wrap">
                    <span class="btn-spinner dark"></span> Resending...
                  </span>
                  <span *ngIf="!isResendLoading && resendCountdown > 0">
                    Resend OTP in {{ resendCountdown }}s
                  </span>
                  <span *ngIf="!isResendLoading && resendCountdown === 0">Resend OTP</span>
                </button>
              </div>

              <div *ngIf="loginError" class="login-error-banner">
                <i class="bi bi-exclamation-triangle-fill"></i>
                <span>{{ loginError }}</span>
              </div>

              <button
                type="button"
                class="btn-login"
                (click)="onVerifyOtp()"
                [disabled]="isLoading || !isOtpComplete"
                [class.loading]="isLoading"
              >
                <span *ngIf="!isLoading"><i class="bi bi-shield-check"></i> Verify OTP</span>
                <span *ngIf="isLoading" class="spinner-wrap">
                  <span class="btn-spinner"></span> Verifying...
                </span>
              </button>
            </section>
          </div>

          <div class="divider-or"><span>or</span></div>

          <button class="btn-register" type="button" (click)="onRegister()">
            <i class="bi bi-person-plus"></i>
            New User? Register Here
          </button>

          <a *ngIf="!isOtpStep" routerLink="/track-application" class="btn-track-application">
            <i class="bi bi-clipboard2-check"></i>
            Track Application
          </a>

          <div class="security-note">
            <i class="bi bi-shield-lock-fill"></i>
            <span
              >Your connection is secured. This is an official Government of Tamil Nadu
              portal.</span
            >
          </div>
        </div>
      </section>
    </div>
  </main>

  <!-- Registration Type Selection Modal -->
  <div class="reg-modal-backdrop" *ngIf="showRegTypeModal" (click)="closeRegTypeModal()">
    <div class="reg-modal-content" (click)="$event.stopPropagation()">
      <div class="reg-modal-header">
        <h3>Choose Registration Type</h3>
        <button
          type="button"
          class="reg-modal-close"
          (click)="closeRegTypeModal()"
          aria-label="Close"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="reg-modal-body">
        <p class="reg-modal-subtitle">
          Please select the registration type suitable for your organization to proceed.
        </p>
        <div class="reg-cards-grid">
          <!-- Manufacturing Card -->
          <div class="reg-selection-card" (click)="selectRegistrationType('MANUFACTURING')">
            <div class="card-icon-wrapper manufacturing">
              <i class="bi bi-buildings-fill"></i>
            </div>
            <div class="card-text-wrapper">
              <h4 class="card-title">Manufacturing</h4>
              <p class="card-desc">
                For Cement plants, Brick manufacturers, and other Fly Ash processing industries.
              </p>
            </div>
            <i class="bi bi-arrow-right-short card-arrow"></i>
          </div>

          <!-- Non-Manufacturing Card -->
          <div class="reg-selection-card" (click)="selectRegistrationType('NON_MANUFACTURING')">
            <div class="card-icon-wrapper non-manufacturing">
              <i class="bi bi-journal-check"></i>
            </div>
            <div class="card-text-wrapper">
              <h4 class="card-title">Non-Manufacturing</h4>
              <p class="card-desc">
                For Government agencies, infrastructure development, roadworks, and other
                non-manufacturing uses.
              </p>
            </div>
            <i class="bi bi-arrow-right-short card-arrow"></i>
          </div>

          <!-- Trader Card -->
          <div class="reg-selection-card" (click)="selectRegistrationType('TRADE')">
            <div class="card-icon-wrapper trade">
              <i class="bi bi-shop"></i>
            </div>
            <div class="card-text-wrapper">
              <h4 class="card-title">Trader</h4>
              <p class="card-desc">
                For traders and distributors involved in Fly Ash procurement and supply.
              </p>
            </div>
            <i class="bi bi-arrow-right-short card-arrow"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
